import React from "react";
import { Link, useLocation } from "react-router-dom";
import RadioButtonChecked from "assets/svgs/RadioButtonChecked";
import RadioButtonUnchecked from "assets/svgs/RadioButtonUnchecked";

const SelectInventory = () => {
  const location = useLocation(); 
  const currentPath = location.pathname;

  return (
    <div className="w-full bg-white flex flex-col gap-3 pb-4 rounded-xl shadow-sm">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between w-full px-3 pt-6">
        <p className="text-dark1 font-semibold  text-sm sm:text-lg">
          Select Inventory Add Option
        </p>
      </div>

      <div className="w-full grid  grid-cols-1 sm:grid-cols-2 gap-4 px-3">
        {/* Add Single Inventory */}
        <Link to="/app/inventory/add">
          <div className="bg-background h-[52px] rounded-[8px] px-3 flex justify-between items-center">
            <p className="text-sm md:text-base text-[#3A3541AD] font-normal">
              Add Single Inventory
            </p>
            {currentPath === "/app/inventory/add" ? (
              <RadioButtonChecked />
            ) : (
              <RadioButtonUnchecked />
            )}
          </div>
        </Link>

        {/* Upload by CSV / XLSX */}
        <Link to="/app/inventory/upload">
          <div className="bg-background h-[52px] rounded-[8px] px-3 flex justify-between items-center">
            <p className="text-sm md:text-base text-[#3A3541AD] font-normal">
              Upload by .csv and .xlsx File
            </p>
            {currentPath === "/app/inventory/upload" ? (
              <RadioButtonChecked />
            ) : (
              <RadioButtonUnchecked />
            )}
          </div>
        </Link>
      </div>
    </div>
  );
};

export default SelectInventory;
